export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In progress"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completed"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])}
}